// @mui material components
import Card from '@mui/material/Card'

// Material Dashboard 2 React components
import MDBox from 'components/MDBox'
import MDButton from 'components/MDButton'
import MDTypography from 'components/MDTypography'

import OTPInput from 'components/OTPInput'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { sendOtp, verifyOtp } from 'store/reducers/authSlice'

function VerifyOTPPage() {

  const navigate = useNavigate()

  const dispatch = useDispatch()
  
  const { isSendingOtp, isOtpSent, user } = useSelector((state) => state.userData);

  const [otpValue, setOtpValue] = useState('')
  const [isResendEnabled, setIsResendEnabled] = useState(false);
  const [timer, setTimer] = useState(0);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isOTPVerified, setIsOTPVerified] = useState(false);
  const [submitCounter, setSubmitCounter] = useState(0)

  const startTimer = () => {
    setIsResendEnabled(false);
    setTimer(60); // Set timer for 60 seconds
    const countdown = setInterval(() => {
      setTimer((prev) => {
        if (prev <= 1) {
          clearInterval(countdown);
          setIsResendEnabled(true);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };
  
  useEffect(() => {
    startTimer();
  }, []);
  
  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (isOTPVerified) return
      if (!isOTPVerified) { 

        event.preventDefault();
        
        localStorage.clear()
        
        event.returnValue = '';
      }
    };
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [isOTPVerified]);
  
  const handleResendOtp = async () => {
    try {
      await dispatch(sendOtp());
      startTimer();
    } catch (error) {
      console.log({ error });
    }
  };

  const handleVerifyOtp = async () => {

    if (otpValue.length < 4 || isSendingOtp || isSubmitting) return
    
    try {
      setIsSubmitting(true)
      await dispatch(verifyOtp({
        otp: otpValue
      }));      
      setIsOTPVerified(true)
      navigate(`/`, { replace: true });
    } catch (error) {
      setOtpValue('');
      setSubmitCounter(prev => prev + 1);
    }
    finally {
      setIsSubmitting(false)
    }
  };

  const handleOTPChange = (value) => {
    setOtpValue(value);
  };

  return (
    <Card sx={{ minWidth: '330px' }}>
      <MDBox
        variant='gradient'
        bgColor='info'
        borderRadius='lg'
        coloredShadow='info'
        mx={2}
        mt={-3}
        p={2}
        mb={1}
        textAlign='center'>
        <MDTypography variant='h4' fontWeight='medium' color='white' mt={1}>
          Verify OTP
        </MDTypography>
      </MDBox>
      <MDBox pt={4} pb={3} px={3}>
        <MDBox component='form' role='form'>
          <MDTypography variant='h6' mb={2}>
            A 4 Digit OTP has been send to {user?.maskedPhoneNumber}.
          </MDTypography>
          <MDBox mb={2}>
            <MDBox
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 2,
              }}>
              <OTPInput
                key={submitCounter}
                separator={<span>-</span>}
                value={otpValue}
                onChange={handleOTPChange}
                onSubmitOTP={handleVerifyOtp}
                length={4}
              />
            </MDBox>
          </MDBox>
          <MDBox
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '4px',
            }}>
            <MDTypography sx={{ color: 'gray', fontSize: '16px' }}>Didn't receive the code?</MDTypography>
            <MDButton
              sx={{
                all: 'unset',
                cursor: 'pointer',
                fontSize: '16px',
                fontWeight: '500',
                color: '#007aff',
              }}
              disableRipple
              onClick={handleResendOtp}
              disabled={(isOtpSent || isSendingOtp) && !isResendEnabled}
              type='button'
            >
              Resend
            </MDButton>
            {(!isResendEnabled) && <MDTypography sx={{ color: 'gray', fontSize: '16px' }}>in {timer}.</MDTypography>}
          </MDBox>
          <MDBox mt={4} mb={1}>
            <MDButton type='button' variant='gradient' color='info' fullWidth
              disabled={otpValue.length < 4 || isSendingOtp || isSubmitting} isLoading={isSubmitting}
              onClick={handleVerifyOtp}
            >
              Submit OTP
            </MDButton>
          </MDBox>
        </MDBox>
      </MDBox>
    </Card>
  );
};

export default VerifyOTPPage
